import React from "react";
import { Helmet } from "react-helmet-async";
import "./UserGuide.css";


function FAQ() {

  return (

    <div className="user-guide-page">

      {/* SEO META */}
      <Helmet>
      <title>FAQ | Frequently Asked Questions - Online Pharmacy</title>
      <meta
        name="description"
        content="Find answers to frequently asked questions about ordering medicines, prescriptions, delivery time, payments, and support."
      />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://realgenericshop.com/faq" />
    </Helmet>


      <div className="user-guide-container">

        <h1 className="user-guide-title">
          Frequently Asked Questions (FAQ)
        </h1>

        <div className="user-guide-content">

          <h3>
            1. How do I place an order?
          </h3>

          <p>
            You can browse products, add them to your cart,
            and proceed to checkout. Follow the instructions
            to complete your purchase securely.
          </p>

          <h3>
            2. Do I need a prescription?
          </h3>

          <p>
            Yes, for certain medicines a valid prescription
            from a licensed doctor is required.
          </p>

          <h3>
            3. How long does delivery take?
          </h3>

          <p>
            Delivery usually takes 2–5 business days
            depending on your location.
          </p>

          <h3>
            4. Are the medicines genuine?
          </h3>

          <p>
            Yes, all medicines sold on MediCare are
            100% genuine and sourced from licensed pharmacies.
          </p>

          <h3>
            5. Can I return my order?
          </h3>

          <p>
            Returns are accepted only for damaged or
            incorrect products within the specified return window.
          </p>

          <h3>
            6. What payment methods are available?
          </h3>

          <p>
            We support multiple payment options including
            debit/credit cards, UPI, and net banking.
          </p>

          <h3>
            7. How can I contact support?
          </h3>

          <p>
            You can reach our support team via email or phone.
            We are available 24/7 to assist you.
          </p>

        </div>

      </div>

    </div>

  );

}

export default FAQ;